export var QURE_AIRA_CREATOR_EMAIL = "qure@qure.ai";
export var DEFAULT_LINKED_RESOURCES = {
  appointments: [],
  encounters: [],
  reports: []
};
export var ResourceLinkingTabs = /*#__PURE__*/function (ResourceLinkingTabs) {
  ResourceLinkingTabs["APPOINTMENTS"] = "appointments";
  ResourceLinkingTabs["ENCOUNTERS"] = "encounters";
  ResourceLinkingTabs["REPORTS"] = "reports";
  return ResourceLinkingTabs;
}({});